import "./index.scss";
import React from "react";
import logo from "../../assets/images/COMDEX_Logo.png";
import { Link } from "react-router-dom";
import telegram from "../../assets/images/telegram.png";
import M_logo from "../../assets/images/M__icon.svg";
import doc_logo from "../../assets/images/doc__icon.svg";
import twitter from "../../assets/images/twitter.svg";
import doc from "../../assets/Light Paper/Comdex-Litepaper.pdf"
const Footer = () => {
  return (
    <section>
      <div className="bg-container">
        <div className="container">
          <div className="footer-main-container">
            <div className="footer-container">
              <div className="footer-left">
                <img src={logo} alt="error" />
                <div>info@comdex.one</div>
              </div>
              <div className="footer-right">
                <ul>
                  <li>
                    <a href="https://comdex.one/contactus" target="_blank" aria-label="ContactUs" rel="noreferrer">Contact Us</a>
                  </li>
                  <li>
                    <a target="_blank" href="https://t.me/ComdexChat" aria-label="Telegram" rel="noreferrer">
                      <img src={telegram} alt="telegram" />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://twitter.com/ComdexOfficial" aria-label="Twitter" rel="noreferrer">
                      <img src={twitter} alt="twitter" />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://blog.comdex.one/?gi=6de71afd54b0" aria-label="Medium" rel="noreferrer">
                      <img src={M_logo} alt="medium" />
                    </a>
                  </li>
                  <li>
                    <a href={doc} download={true}>
                      <img src={doc_logo} alt="doc" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
